import jsPDF from 'jspdf';

export const generateBasicPDF = () => {
  const pdf = new jsPDF();

  const currentDate = new Date().toLocaleDateString();
  pdf.text(currentDate, 10, 10);

  const pdfBlob = pdf.output('blob');
  const pdfFile = new File([pdfBlob], 'current_date.pdf', { type: 'application/pdf' });

  return pdfFile;
};
